import { useState } from 'react';

/**
 * Custom hook for managing modal states and configurations
 * @returns {object} - Modal management functions and state
 */
export const useModalManager = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    type: 'confirmation',
    title: '',
    message: '',
    onConfirm: () => {},
    confirmText: 'Confirm',
    declineText: 'Cancel',
    position: 'center'
  });

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  const showToast = (title, message, type = 'success') => {
    setModalConfig({
      isOpen: true,
      type: 'toast',
      title,
      message,
      position: 'top-right',
      onConfirm: closeModal,
      confirmText: 'OK',
      declineText: 'Cancel'
    });
    
    // Use a ref to track if component is still mounted
    const timeoutId = setTimeout(() => {
      try {
        closeModal();
      } catch (error) {
        // Silently handle if component is unmounted
        console.warn('Modal cleanup after unmount:', error);
      }
    }, 3000);
    
    // Return cleanup function
    return () => clearTimeout(timeoutId);
  };

  const showPremiumModal = () => {
    setModalConfig({
      isOpen: true,
      type: 'premium',
      title: '🚀 Oops! This is a Premium Feature',
      message: 'Upgrade now to unlock advanced export features and take your store management to the next level!',
      onConfirm: () => {
        window.open('https://wpazleen.com/shop-explorer-pricing/', '_blank');
        closeModal();
      },
      confirmText: 'Upgrade Now',
      declineText: 'Maybe Later'
    });
  };

  const showConfirmationModal = (title, message, onConfirm) => {
    setModalConfig({
      isOpen: true,
      type: 'confirmation',
      title,
      message,
      onConfirm: () => {
        onConfirm();
        closeModal();
      },
      confirmText: 'Confirm',
      declineText: 'Cancel'
    });
  };

  return {
    modalOpen,
    setModalOpen,
    modalConfig,
    closeModal,
    showToast,
    showPremiumModal,
    showConfirmationModal,
  };
};